var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTruckTail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 19,
    viewBox: "0 0 43 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.75 -1.75541e-06L2.59088 0L2.59088 16.5217L28.0682 16.5217C28.0683 17.8904 29.2283 18.9999 30.6592 18.9999C32.09 18.9999 33.25 17.8904 33.2501 16.5217L34.1137 16.5217C34.1138 17.8904 35.2737 18.9999 36.7046 18.9999C38.1355 18.9999 39.2955 17.8904 39.2955 16.5217L42.75 16.5217L42.75 -1.75541e-06Z",
    fill: "#155878"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 12.0909,
    width: 4.31818,
    height: 1.72727,
    fill: "#155878"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckTail);
export default __webpack_public_path__ + "static/media/TruckTail.008346fd2aa194e20d2e31f3fc475831.svg";
export { ForwardRef as ReactComponent };